import { message } from "antd";
import { isServerRequestError } from "@obsbot/remo-server-api";
import { RemoI18n } from "@obsbot/remo-i18n";

export const errorTips = (e: unknown): void => {
    if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test") {
        console.error(e);
        // console.error() cannot show properties of the error object
        console.log(Object.assign({}, e));
    }

    if (isServerRequestError(e)) {
        let content = e.errorMessage
            ? RemoI18n.t(e.errorMessage)
            : RemoI18n.t("error-code-error", { code: `${e.errorCode}` });
        if (!e.errorMessage && e.serverMessage) {
            content += " (" + e.serverMessage + ")";
        }
        void message.error({ content, key: e.errorCode });
    } else if ((e as Error).message) {
        const { message: content, message: key } = e as Error;
        void message.error({ content, key });
    } else {
        void message.error({ content: RemoI18n.t("unknown-error"), key: "unknown" });
    }
};
